// Gate E6.12: AppLogo with CSS blue circle background
// The dog PNG is transparent; the blue circle is created with CSS
// Dog is shifted down ~12% to feel "anchored" with chin cropped at bottom
// Gate I14: Now supports dynamic logo URL via AppBrandingContext

import { useAppBranding } from "@/contexts/app-branding";

interface AppLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
}

export function AppLogo({ className = "", size = "md" }: AppLogoProps) {
  const { logoUrl } = useAppBranding();
  
  const sizeConfig = {
    sm: { wrapper: "h-8 w-8", imgScale: "w-[95%]" },
    md: { wrapper: "h-10 w-10", imgScale: "w-[95%]" },
    lg: { wrapper: "h-16 w-16", imgScale: "w-[95%]" },
    xl: { wrapper: "h-24 w-24", imgScale: "w-[95%]" },
    "2xl": { wrapper: "h-36 w-36", imgScale: "w-[95%]" },
  };

  const config = sizeConfig[size];

  return (
    <div
      className={`
        ${config.wrapper}
        rounded-full
        bg-primary
        overflow-hidden
        flex
        items-end
        justify-center
        flex-shrink-0
        ${className}
      `}
    >
      <img
        src={logoUrl}
        alt="App logo"
        className={`${config.imgScale} object-contain translate-y-[12%]`}
      />
    </div>
  );
}

export function AppBrandingText({ className = "" }: { className?: string }) {
  const { appName } = useAppBranding();
  
  const parts = appName.split(" ");
  const firstWord = parts[0] || appName;
  const rest = parts.slice(1).join(" ");
  
  return (
    <span className={`text-lg tracking-tight ${className}`} data-testid="text-app-title">
      <span className="font-bold">{firstWord}</span>
      {rest && (
        <>
          {" "}
          <span className="font-normal">{rest}</span>
        </>
      )}
    </span>
  );
}
